export default __webpack_public_path__ + "static/media/set_2_360-1.10845fa8.svg";